// SignIn Actions
export const SIGNIN_START = "SIGNIN_START";
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SIGNIN_ERROR = "SIGNIN_ERROR";

//Forgot Password Actions
export const START_FORGOT_PASSWORD = "START_FORGOT_PASSWORD";
export const SUCCESS_FORGOT_PASSWORD = "SUCCESS_FORGOT_PASSWORD";
export const ERROR_FORGOT_PASSWORD = "ERROR_FORGOT_PASSWORD";

//Reset Password Actions
export const START_RESET_PASSWORD = "START_RESET_PASSWORD";
export const SUCCESS_RESET_PASSWORD = "SUCCESS_RESET_PASSWORD";
export const ERROR_RESET_PASSWORD = "ERROR_RESET_PASSWORD";

// Verify Reset Password Link Actions
export const START_VERIFY_RESET_PASSWORD_LINK =
  "START_VERIFY_RESET_PASSWORD_LINK";
export const SUCCESS_VERIFY_RESET_PASSWORD_LINK =
  "SUCCESS_VERIFY_RESET_PASSWORD_LINK";
export const ERROR_VERIFY_RESET_PASSWORD_LINK =
  "ERROR_VERIFY_RESET_PASSWORD_LINK";

//Signout Actions
export const LOGOUT_START = "LOGOUT_START";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "LOGOUT_ERROR";

//Rest InitialState Actions
export const RESET_STATE = "RESET_STATE";

//Create Pharmacy Password Actions
export const START_PHARMACY_CREATE_PASSWORD = "START_PHARMACY_CREATE_PASSWORD";
export const SUCCESS_PHARMACY_CREATE_PASSWORD =
  "SUCCESS_PHARMACY_CREATE_PASSWORD";
export const ERROR_PHARMACY_CREATE_PASSWORD = "ERROR_PHARMACY_CREATE_PASSWORD";
